import { render, staticRenderFns } from "./WhatsappOfferPresetDelivery.vue?vue&type=template&id=0946e0e5&scoped=true&lang=pug&"
import script from "./WhatsappOfferPresetDelivery.vue?vue&type=script&lang=js&"
export * from "./WhatsappOfferPresetDelivery.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappOfferPresetDelivery.vue?vue&type=style&index=0&id=0946e0e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946e0e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VCard,VChip,VCol,VDivider,VForm,VIcon,VImg,VProgressCircular,VRow,VSpacer,VTextField,VTextarea})
